const shortDate = new Intl.DateTimeFormat('sv-SE', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

function parse(date: string) {
  return new Date(`${date}T00:00:00Z`);
}

/** "5 okt" for a YYYY-MM-DD date */
export function formatShortDate(date: string): string {
  return shortDate.format(parse(date)).replace('.', '');
}

/** "20 sep – 19 okt" for a period's first and last day (YYYY-MM-DD) */
export function formatPeriodRange(startDate: string, lastDate: string): string {
  return `${formatShortDate(startDate)} – ${formatShortDate(lastDate)}`;
}

/** Last day of a period given its exclusive end date */
export function lastDayBefore(endDate: string): string {
  const d = parse(endDate);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

export function shiftPeriod(year: number, month: number, delta: number) {
  const index = year * 12 + (month - 1) + delta;
  return { year: Math.floor(index / 12), month: (index % 12) + 1 };
}
